<ws-modal-wrapper headerLabel="Document Intake Item Exception"
                  [disableCancel]="loading"
                  [disableSave]="loading || !isValid()"
                  [loading]="loading"
                  (save)="save()"
                  (cancel)="cancel()">
    <div class="document-processing-exception-modal">
        @if (!loading) {
            <div class="row">
                <div class="col col-2">
                    Action:
                </div>
                <div class="col col-10">
                    <div class="radio">
                        <label>
                            <input type="radio"
                                   name="action-selection"
                                   [value]="DocumentExceptionActions.REASSIGN_ITEM"
                                   [(ngModel)]="actionType"
                                   required
                                   (change)="createComment()">
                            <span>Reassign item</span>@if (multipleTasks) {
                            <span>s</span>
                        }
                        </label>
                    </div>
                    @if (actionType === DocumentExceptionActions.REASSIGN_ITEM) {
                        <div>
                            <user-team-picker [(user)]="reassign"
                                              [entityTypeScope]="'Instance'"
                                              [entityIdScope]="instanceId"
                                              (userChange)="createComment()">
                            </user-team-picker>
                        </div>
                    }
                    @if ((multipleTasks || rejectedByUser) &&
                    !(intakeItem && intakeItem.clientInstanceId && clientInstanceId !== instanceId ||
                        clientInstanceId && clientInstanceId !== instanceId)) {
                        <div
                            class="radio">
                            <label ng-style="disableBounceRejected ? {'color':'lightgray'} : {}">
                                <input type="radio"
                                       name="action-selection"
                                       required
                                       [disabled]="disableBounceRejected"
                                       [value]="DocumentExceptionActions.BOUNCE_REJECTED"
                                       [(ngModel)]="actionType">
                                @if (multipleTasks) {
                                    <span>Reassign to rejector@if (rejectedByUser) {
                                        <span
                                        > ({{ rejectedByUser.firstName }} {{ rejectedByUser.lastName }})</span>
                                    }</span>
                                }
                                @if (!multipleTasks) {
                                    <span
                                    >Reassign item to rejector ({{ rejectedByUser.firstName }} {{ rejectedByUser.lastName }})</span>
                                }
                            </label>
                        </div>
                    }
                    <div class="radio">
                        <label>
                            <input type="radio"
                                   name="action-selection"
                                   required
                                   [value]="DocumentExceptionActions.ESCALATE_ITEM"
                                   [(ngModel)]="actionType"
                                   (change)="createComment()">
                            <span>Escalate items
                                @if (intakeItem && intakeItem.clientInstanceId && clientInstanceId !== instanceId) {
                                    <span> to contact user ({{ intakeItem.contactUser.firstName }} {{ intakeItem.contactUser.lastName }})</span>
                                }
                                @if (!intakeItem && clientInstanceId && clientInstanceId !== instanceId) {
                                    <span
                                    > to contact user ({{ contactUser.firstName }} {{ contactUser.lastName }})</span>
                                }</span>
                        </label>
                    </div>
                    @if (actionType === DocumentExceptionActions.ESCALATE_ITEM &&
                    (multipleTasks && (!clientInstanceId || clientInstanceId === instanceId) || !multipleTasks && (!intakeItem.clientInstanceId || clientInstanceId === instanceId))) {
                        <div>
                            <user-team-picker [(user)]="escalate"
                                              [entityTypeScope]="'Instance'"
                                              [entityIdScope]="instanceId"
                                              (userChange)="createComment()">
                            </user-team-picker>
                        </div>
                    }
                    <div class="radio">
                        <label>
                            <input type="radio"
                                   name="action-selection"
                                   required
                                   [value]="DocumentExceptionActions.REQUEST_RESEARCH"
                                   [(ngModel)]="actionType"
                                   (change)="createComment()">
                            <span>Request Research</span>
                        </label>
                    </div>
                    @if (actionType === DocumentExceptionActions.REQUEST_RESEARCH) {
                        <div>
                            <user-team-picker [(user)]="request"
                                              [entityTypeScope]="'Instance'"
                                              [entityIdScope]="instanceId"
                                              (userChange)="createComment()">
                            </user-team-picker>
                        </div>
                    }
                    @if (showRequestTaxRateSetups) {
                        <div class="radio">
                            <label>
                                <input type="radio"
                                       name="action-selection"
                                       required
                                       [value]="DocumentExceptionActions.REQUEST_TAX_RATE_SETUPS"
                                       [(ngModel)]="actionType"
                                       (change)="createComment()">
                                <span>Request tax rate setups</span>
                            </label>
                        </div>
                    }
                    @if (actionType === DocumentExceptionActions.REQUEST_TAX_RATE_SETUPS) {
                        <div>
                            <user-team-picker [(user)]="taxRateSetups"
                                              [entityTypeScope]="'Instance'"
                                              [entityIdScope]="instanceId"
                                              (userChange)="createComment()">
                            </user-team-picker>
                        </div>
                    }
                    <div class="radio">
                        <label>
                            <input type="radio"
                                   name="action-selection"
                                   required
                                   [value]="DocumentExceptionActions.REJECT_ITEM"
                                   [(ngModel)]="actionType"
                                   (change)="createComment()">
                            @if (!multipleTasks) {
                                <span
                                >Reject to contact user ({{ intakeItem.contactUser.firstName }} {{ intakeItem.contactUser.lastName }})</span>
                            }
                            @if (multipleTasks) {
                                <span>Reject to contact user@if (contactUser) {
                                    <span
                                    > ({{ contactUser.firstName }} {{ contactUser.lastName }})</span>
                                }</span>
                            }
                        </label>
                    </div>
                    <div class="radio">
                        <label>
                            <input type="radio"
                                   name="action-selection"
                                   required
                                   [value]="DocumentExceptionActions.CLOSE_ITEM"
                                   [(ngModel)]="actionType"
                                   (change)="createComment()">
                            <span>Close item@if (multipleTasks) {
                                <span>s</span>
                            } (Added in error)</span>
                        </label>
                    </div>
                    @if (hasExceptionStatus || multipleTasks) {
                        <div class="radio">
                            <label [ngStyle]="disableClearException ? {'color':'lightgray'} : {}">
                                <input [disabled]="disableClearException"
                                       type="radio"
                                       name="action-selection"
                                       required
                                       [value]="DocumentExceptionActions.CLEAR_EXCEPTION"
                                       [(ngModel)]="actionType"
                                       (change)="createComment()">
                                <span>Clear Exception@if (multipleTasks) {
                                    <span>s</span>
                                }</span>
                            </label>
                        </div>
                    }
                </div>
            </div>
        }
        @if (!loading) {
            <div class="row" style="margin-top: 20px;">
                <div class="col col-2">
                    Comment:
                </div>
                <div class="col col-10">
                    <textarea class="form-control" cols="40" rows="5" [(ngModel)]="commentBody"></textarea>
                </div>
            </div>
        }
    </div>
</ws-modal-wrapper>
